export enum BridgeWidgetId {
  HealthRates = 'healthRates',
  Gauges = 'gauges',
  Loglytics = 'loglytics',
  DeviceChart = 'deviceChart',
  AffectedChart = 'affectedChart',
  LogsChart = 'logsChart'
}

export const GRID_COLUMNS = 12;

export interface WidgetLayout {
  id: BridgeWidgetId;
  visible: boolean;
  span: number;
}
